import { Component, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-myob-service-work-orders-grid',
  templateUrl: './myob-service-work-orders-grid.component.html',
  styleUrls: ['./myob-service-work-orders-grid.component.css']
})
export class MyobServiceWorkOrdersGridComponent implements OnInit {


  @Input() sent_data?: any; // not used

  // Grid Vars
  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 25 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;





  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };
  today = new Date();
  initialPage: { pageSize: number; };
  open_jobs_count: any;
  myobCustomers: Object;
  arrCase: object[];
  Items: any;
  myobCustomerCreatedData: any;
  brand_types: any;
  users: any;
  usersPrimary: any;
  job_table_clients: any;
  btLocalRecord: any;
  changeObject: any;
  userLocalRecord: any;
  job_table_clients3: any;
  UID_new_customer: any;
  returned_update: Object;
  myobCustomerDeleteData: Object;
  myobCustomerUpdateData: Object;
  customerItem: any;
  myobContactListMapped: any;
  myobCustomer: Object;
  set_RowVersion: any;
  IsIndividual: any;
  // myobInvoices: Object;
  myobInvoiceDeleteData: Object;
  myobInvoice: Object;
  invoiceItem: any;
  myobPurchases: Object;

  constructor(
    private http: HttpClient, private router: Router,
    private route: ActivatedRoute, private _demoService: DemoService,
   public datepipe: DatePipe,  public gfunc: GlobalFunctionsService,
   public toastr: HotToastService,
   vcr: ViewContainerRef,
  ) { 
   
  }

  ngOnInit() {

// load the SOP Brands/Clients
// this.mapJobTableLiveClients();

    // Load the data
          this.getMyobPurchases(); 

          // Grid Options
          this.toolbarOptions = ['ExcelExport', 'Search'];
          this.initialPage = { pageSize:5 };
          this.filterOptions = {
             type: 'Menu'
          };
         // this.groupOptions = { columns: [''] }; // sets auto grouping for the grid
          this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
          this.dateFormat = 'dd/MM/yyyy hh:mm a';
          this.filter = { params: { format: this.dateFormat } };
         // this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' } ] };
      
      
      // end date filter options
          // End Grid Options
  }



  // :: Grid Functions


// https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);

   // this.search_results = pdfdata.records; // need this if a grouping is set.
  /*   this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

};


toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}

  // :: Grid Functions



  // uses demo services but calls to myob
  public getMyobPurchases() {

    this.gfunc.myobChecker();

    return  this._demoService.getMyobPurchases().subscribe(
        data => { this.myobPurchases = data;
          const res = data[0];
           // https://www.concretepage.com/questions/577
           this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
           // console.log(this.arrCase);
           this.Items = data['Items'] ;
           this.sent_data = this.Items;
  
           // console.log(this.Items);
          // this.Address = this.Items['Address'];
    // return this.myobCustomers;
  
    // Map the data top the new model system
   // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));
  
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         // console.error(err);
        },
        // () => console.log('done loading Trace Types')
      );
  
    }




  // // uses demo services but calls to myob
  // public getMyobInvoices() {
  //   return  this._demoService.getMyobInvoices().subscribe(
  //       data => { this.myobInvoices = data;
  //         const res = data[0];
  //          // https://www.concretepage.com/questions/577
  //          this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
  //          // console.log(this.arrCase);
  //          this.Items = data['Items'] ;
  //          this.sent_data = this.Items;
  
  //          // console.log(this.Items);
  //         // this.Address = this.Items['Address'];
  //   // return this.myobCustomers;
  
  //   // Map the data top the new model system
  //  // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));
  
  //       },
  //       err => {
  //         // this.toastr.error('You need to login to MYOB again, Connection lost!');
  //        // console.error(err);
  //       },
  //       // () => console.log('done loading Trace Types')
  //     );
  
  //   }



  // uses demo services but calls to myob
  public getMyobCustomers() {
    return  this._demoService.getMyobCustomers().subscribe(
        data => { this.myobCustomers = data;
          const res = data[0];
           // https://www.concretepage.com/questions/577
           this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
           // console.log(this.arrCase);
           this.Items = data['Items'] ;
  
           // console.log(this.Items);
          // this.Address = this.Items['Address'];
    // return this.myobCustomers;
  
    // Map the data top the new model system
   // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));
  
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         // console.error(err);
        },
        // () => console.log('done loading Trace Types')
      );
  
    }

    createMyobCustomer(model){
      return  this._demoService.createMyobCustomer(model).subscribe(
        data => { this.myobCustomerCreatedData = data;
          const res = data[0];
         
          // // https://www.concretepage.com/questions/577
          //  this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
          //  // console.log(this.arrCase);
          //  this.Items = data['Items'] ;

  
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         // console.error(err);
        },
        // () => console.log('done loading Trace Types')
      );

    }



    
    createMyobCustomerModel(model){
      if (confirm('We are about to Sync this Business with MYOB as a client/customer, Are you Sure?')) {

      // :: Need to create a new customer model based on myob defaul and required fields for insert of new customer
      const data2 = {
        'CompanyName': model.name,
        'LastName': model.surname,
        'FirstName': model.name,
        'IsIndividual': false,
        'DisplayID': 'TSA' + model.brand_id,
        'IsActive' : true,

        'Addresses' : [
          {
          'Location' : 1,
          'Street' : model.adddress_1,
          'City' : model.suburb,
          'State' : model.state,
          'PostCode' : model.postcode,
          'Country' : model.country,
          'Phone1' : model.phone,
          'Phone2' : '',
          'Phone3' : '',
          'Fax' : model.fax,
          'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
          'Website' : model.website,
          'ContactName' : '',
          'Salutation' : ''
          }
          ],
          'Notes' : model.brand_notes,

          'CustomField1' : {
            'Label' : 'brand_id',
            'Value' : model.brand_id
            },

        'SellingDetails': {
            'SaleLayout' : 'NoDefault',
            'PrintedForm' : 'null',
            'InvoiceDelivery' : 'Print',
            'ABN' : model.abn,
            'TaxCode': {
              'UID': this.gfunc.myob_TaxCode,
              'Code': 'GST'
              // "URI": "https://arl2.api.myob.com/accountright/8449d6c9-2fdc-412a-8412-b6c0a058beba/GeneralLedger/TaxCode/8d273078-fe1d-4c16-b318-ec7a2b7fb2fe"
            },
            'FreightTaxCode': {
              'UID': this.gfunc.myob_FreightTaxCode,
              'Code': 'GST'
              // "URI": "https://arl2.api.myob.com/accountright/8449d6c9-2fdc-412a-8412-b6c0a058beba/GeneralLedger/TaxCode/8d273078-fe1d-4c16-b318-ec7a2b7fb2fe"
            }
          }
        // "UseCustomerTaxCode": false
       };



// :: Ideally need to get a response from insert of the UID of the customer to insert back in sop brands to know th e link has taken place.
        this._demoService.createMyobCustomer(data2).subscribe(
        data => { this.myobCustomerCreatedData = data;
          let res = data[0];
          let new_data_object = JSON.parse(this.myobCustomerCreatedData);

          // console.log('new_data date: ' + new_data_object.date);
          // console.log('new_data Location ' + new_data_object.location);
          // remove the last 25 chars to get the inserted id.
          // get the length of the string and then splice 25 chars less from the total length.
          let location_string = new_data_object.location;
          // let data_object_length = location_string.length;
          // let start_from = data_object_length - 25;
          // let data_object_splice = location_string.slice( start_from , data_object_length);
          // this.UID_new_customer = data_object_splice;
          // console.log('Last inserted myobID: ' + this.UID_new_customer);

          // get everything after last dash 
          let slug = location_string.split('/').pop(); // 2020
          console.log('UUID slug: ' + slug);

          model.myob_id = slug;
          model.sync_with_myob = 1;



          // :: Need to lookup myoub get UID/myobid and fill rest of model.vars.



                    // need to pass the brand model here as its updatting the full SOP brand details.
                    this._demoService.getMyobCustomerMapped(slug, model).subscribe(
                       data4 => {
                        console.log(data4);
                        res = data4[0];
                      // many
                        // this.myobContactListMapped = data.data;
                      //single
                        this.myobContactListMapped = data4;
                      // Set the returned Variables Reququied for Update of a Myob Customer.
                      console.log('UID: ' +  data4.UID);
                      console.log('LastModified: ' + data4.LastModified);
                      console.log('RowVersion: ' + data4.RowVersion);
                      console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
                      console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);

                      this.set_RowVersion = data4.RowVersion;
                      this.IsIndividual = data4.IsIndividual;

                      model.IsIndividual = data4.IsIndividual;
                      model.SaleLayout = data4.SellingDetails.SaleLayout;
                      model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
                      model.TaxCode = data4.SellingDetails.TaxCode.UID;
                      model.FreightTaxCode = data4.SellingDetails.FreightTaxCode.UID;
                      model.RowVersion = data4.RowVersion;
                      model.myob_customer_array = JSON.stringify(data4);

                      this.editBrand(model);
                      this.refreshGrid();
                      this.toastr.info('Customer Upgraded In SOP');
                    },
                    error => {
                      // console.error('Error saving Event!');
                       this.toastr.error('Error Updating Brand Myob Details');
                      console.log(error.error);
                     });

                     model.IsIndividual = this.IsIndividual;
                     model.RowVersion = this.set_RowVersion;

   
                      
                        //  model.RowVersion = this.set_RowVersion;
                    //  model.myob_customer_array = JSON.stringify(this.myobContactListMapped);


          // let new_data_string = JSON.stringify(this.myobCustomerCreatedData);
          // console.log('new_data date: ' + new_data_string.date);
          // console.log('new_data date: ' + new_data_string.location);

          // console.log(this.myobCustomerCreatedData.location);
          // // https://www.concretepage.com/questions/577
          //  this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
          //  // console.log(this.arrCase);
          //  this.Items = data['Items'] ;

        
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         console.log(err.error);
        },
        // () => console.log('done loading Trace Types')
      );

      }; // end confirm

    };



    updateMyobCustomerModel2(model){
      if (confirm('We are about to Sync this Business with MYOB and update the myob data, Are you Sure?')) {
        let data_test = {
          'UID': model.myob_id,
          'CompanyName': model.name,
          'LastName': 'My Crazy Name',
          'FirstName': 'Tester',
          'IsIndividual': false,
          'DisplayID': 'TSA' + model.brand_id,
          'Addresses' : [
            {
            'Location' : 1,
            'Street' : model.adddress_1,
            'City' : model.suburb,
            'State' : model.state,
            'PostCode' : model.postcode,
            'Country' : model.country,
            'Phone1' : model.phone,
            'Phone2' : '',
            'Phone3' : '',
            'Fax' : model.fax,
            'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
            'Website' : model.website,
            'ContactName' : '',
            'Salutation' : ''
            },
            {
              'Location' : 2,
              'Street' : model.postal_address_1,
              'City' : model.postal_suburb,
              'State' : model.postal_state,
              'PostCode' : model.postal_postcode,
              'Country' : model.postal_country,
              'Phone1' : model.phone,
              'Phone2' : '',
              'Phone3' : '',
              'Fax' : model.fax,
              'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
              'Website' : model.website,
              'ContactName' : '',
              'Salutation' : ''
              }
            ],
            'Notes' : model.brand_notes,
  
            'CustomField1' : {
              'Label' : 'brand_id',
              'Value' : model.brand_id
              },
  
                            'SellingDetails': {
                'ABN': model.abn,
                'TaxCode': {
                  'UID': this.gfunc.myob_TaxCode
                },
                'FreightTaxCode': {
                  'UID': this.gfunc.myob_FreightTaxCode
                }
          },
          'RowVersion': model.RowVersion,
        };


  this._demoService.updateMyobCustomer(data_test).subscribe(
        data => { this.myobCustomerUpdateData = data;
          let res = data[0];
        
          // turned below into a function to reuse?
        this.lookupCustomerUpdateBrand(model.myob_id, model);
          // model.myob_id = null;
          // model.sync_with_myob = 0;

               // need to pass the brand model here as its updatting the full SOP brand details.
            //    this._demoService.getMyobCustomerMapped(model.myob_id, model).subscribe(
            //     data4 => {
            //      console.log(data4);
            //      res = data4[0];
            //      this.myobContactListMapped = data4;
            //    // Set the returned Variables Reququied for Update of a Myob Customer.
            //   //  console.log('UID: ' +  data4.UID);
            //   //  console.log('LastModified: ' + data4.LastModified);
            //   //  console.log('RowVersion: ' + data4.RowVersion);
            //   //  console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
            //   //  console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);

            //    this.set_RowVersion = data4.RowVersion;
            //    this.IsIndividual = data4.IsIndividual;

            //    model.IsIndividual = data4.IsIndividual;
            //    model.SaleLayout = data4.SellingDetails.SaleLayout;
            //    model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
            //    model.TaxCode = data4.SellingDetails.TaxCode.UID;
            //    model.FreightTaxCode = data4.SellingDetails.FreightTaxCode.UID;
            //    model.RowVersion = data4.RowVersion;
            //    model.myob_customer_array = JSON.stringify(data4);

            //    this.editBrand(model);
            //    this.refreshGrid();
            //    this.toastr.info('CustomerVrs Updated In SOP');
            //  },
            //  error => {
            //    // console.error('Error saving Event!');
            //     this.toastr.error('Error Updating Brand Myob Details');
            //    console.log(error.error);
            //   });


          // this.editBrand(model);
          //   this.refreshGrid();
          this.toastr.success('Brand Details updated with Myob');
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         // console.error(err);
        },
        // () => console.log('done loading Trace Types')
      );

      }; // end confirm

    };



lookupCustomerUpdateBrand(UID, model){
  this._demoService.getMyobCustomerMapped(UID, model).subscribe(
    data4 => {
     console.log(data4);
     let res = data4[0];
     this.myobContactListMapped = data4;
   // Set the returned Variables Reququied for Update of a Myob Customer.
  //  console.log('UID: ' +  data4.UID);
  //  console.log('LastModified: ' + data4.LastModified);
  //  console.log('RowVersion: ' + data4.RowVersion);
  //  console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
  //  console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);

   this.set_RowVersion = data4.RowVersion;
   this.IsIndividual = data4.IsIndividual;

   model.IsIndividual = data4.IsIndividual;
   model.SaleLayout = data4.SellingDetails.SaleLayout;
   model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
   model.TaxCode = data4.SellingDetails.TaxCode.UID;
   model.FreightTaxCode = data4.SellingDetails.FreightTaxCode.UID;
   model.RowVersion = data4.RowVersion;
   model.myob_customer_array = JSON.stringify(data4);

   this.editBrand(model);
   this.refreshGrid();
   this.toastr.info('CustomerVrs Updated In SOP');
 },
 error => {
   // console.error('Error saving Event!');
    this.toastr.error('Error Updating Brand Myob Details');
   console.log(error.error);
  });
}; // end loopup and update function




    updateMyobCustomerModel(model){
      if (confirm('We are about to Sync this Business with MYOB and update the myob data, Are you Sure?')) {

      // :: Need to create a new customer model based on myob defaul and required fields for insert of new customer
      let data3 = {
        'UID': model.myob_id, // update field
        'CompanyName': model.name,
        'LastName': model.surname,
        'FirstName': model.name,
        'IsIndividual': true,
        'DisplayID': 'TSA' + model.brand_id,
        'IsActive' : true,

        'Addresses' : [
          {
          'Location' : 1,
          'Street' : model.adddress_1,
          'City' : model.suburb,
          'State' : model.state,
          'PostCode' : model.postcode,
          'Country' : model.country,
          'Phone1' : model.phone,
          'Phone2' : '',
          'Phone3' : '',
          'Fax' : model.fax,
          'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
          'Website' : model.website,
          'ContactName' : '',
          'Salutation' : ''
          },
          {
            'Location' : 2,
            'Street' : model.postal_address_1,
            'City' : model.postal_suburb,
            'State' : model.postal_state,
            'PostCode' : model.postal_postcode,
            'Country' : model.postal_country,
            'Phone1' : model.phone,
            'Phone2' : '',
            'Phone3' : '',
            'Fax' : model.fax,
            'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
            'Website' : model.website,
            'ContactName' : '',
            'Salutation' : ''
            }
          ],
          'Notes' : model.brand_notes,

          'CustomField1' : {
            'Label' : 'brand_id',
            'Value' : model.brand_id
            },

        'SellingDetails': {
            'SaleLayout' : model.SaleLayout,
            'PrintedForm' : 'null',
            'InvoiceDelivery' : model.InvoiceDelivery,
            'ABN' : model.abn,
            'TaxCode': {
              'UID': model.TaxCode,
            },
            'FreightTaxCode': {
              'UID': model.FreightTaxCode,
            }
          },
        // "UseCustomerTaxCode": false
        'RowVersion': model.RowVersion, // update field.
       };


       let data_test = {
        'UID': model.myob_id,
        'CompanyName': model.name,
        'LastName': 'My Crazy Name',
        'FirstName': 'Tester',
        'IsIndividual': false,
        'DisplayID': 'TSA' + model.brand_id,
        'Addresses' : [
          {
          'Location' : 1,
          'Street' : model.adddress_1,
          'City' : model.suburb,
          'State' : model.state,
          'PostCode' : model.postcode,
          'Country' : model.country,
          'Phone1' : model.phone,
          'Phone2' : '',
          'Phone3' : '',
          'Fax' : model.fax,
          'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
          'Website' : model.website,
          'ContactName' : '',
          'Salutation' : ''
          },
          {
            'Location' : 2,
            'Street' : model.postal_address_1,
            'City' : model.postal_suburb,
            'State' : model.postal_state,
            'PostCode' : model.postal_postcode,
            'Country' : model.postal_country,
            'Phone1' : model.phone,
            'Phone2' : '',
            'Phone3' : '',
            'Fax' : model.fax,
            'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
            'Website' : model.website,
            'ContactName' : '',
            'Salutation' : ''
            }
          ],
          'Notes' : model.brand_notes,

          'CustomField1' : {
            'Label' : 'brand_id',
            'Value' : model.brand_id
            },

        'SellingDetails': {
          'TaxCode': {
            'UID': this.gfunc.myob_TaxCode
          },
          'FreightTaxCode': {
            'UID': this.gfunc.myob_FreightTaxCode
          }
        },
        'RowVersion': model.RowVersion,
      };



// :: Ideally need to get a response from insert of the UID of the customer to insert back in sop brands to know th e link has taken place.
 this._demoService.updateMyobCustomer(data_test).subscribe(
        data => { this.myobCustomerUpdateData = data;
          let res = data[0];
          let new_data_object = JSON.parse(this.myobCustomerCreatedData);

          // console.log('new_data date: ' + new_data_object.date);
          // console.log('new_data Location ' + new_data_object.location);
          // remove the last 25 chars to get the inserted id.
          // get the length of the string and then splice 25 chars less from the total length.
          let location_string = new_data_object.location;
          // let data_object_length = location_string.length;
          // let start_from = data_object_length - 25;
          // let data_object_splice = location_string.slice( start_from , data_object_length);
          // this.UID_new_customer = data_object_splice;
          // console.log('Last inserted myobID: ' + this.UID_new_customer);

          // get everything after last dash 
          let slug = location_string.split('/').pop(); // 2020
          console.log('UUID slug: ' + slug);
          model.myob_id = slug;
          model.sync_with_myob = 1;

                      // TO DO LOOKUP THE RECORD AND GET ROWVERSION AND UPDATE BRAND

                                this.editBrand(model);
                                  this.refreshGrid();

          this.toastr.success('Customer Updated in Myob');
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         console.log(err.error);
        }
      );

      }; // end confirm

    };




    deleteMyobCustomerModel(model){
      if (confirm('This will delete this company from Myob. We cannot undo this, Are you Sure?')) {
  this._demoService.deleteMyobCustomer(model).subscribe(
        data => { this.myobCustomerDeleteData = data;
          let res = data[0];
          model.myob_id = null;
          // model.sync_with_myob = 0; 
                    // Set these from the global setting so I dont have to reset every time.
                    model.TaxCode = this.gfunc.myob_TaxCode;
                    model.FreightTaxCode= this.gfunc.myob_FreightTaxCode;
          model.RowVersion = null;
          this.editBrand(model);
            this.refreshGrid();
          this.toastr.success('Brand Deleted and Un-Linked with Myob');
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         // console.error(err);
        },
        // () => console.log('done loading Trace Types')
      );

      }; // end confirm

    };





    deleteMyobServiceInvoiceModel(model){
      if (confirm('This will delete this Invoice from Myob. We cannot undo this, Are you Sure?')) {
  this._demoService.deleteMyobInvoice(model).subscribe(
        data => { this.myobInvoiceDeleteData = data;
          let res = data[0];
          model.myob_id = null;
          model.sync_with_myob = 0; 
          model.RowVersion = null;
          this.updateSubjectInvoice(model);
            this.refreshGrid();
          this.toastr.success('Invoice Deleted from with Myob');
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         // console.error(err);
        },
        // () => console.log('done loading Trace Types')
      );

      }; // end confirm

    };





    public getMyobInvoice(UID, model){
      this._demoService.getMyobInvoiceMapped(UID, model).subscribe(
        data => { this.myobInvoice = data;
          let res = data[0];
           this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
           // console.log(this.arrCase);
           this.invoiceItem = data['Item'] ;
          // console.log(this.customerItem);
          // this.Address = this.Items['Address'];
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
          console.error(err);
        },
        // () => console.log('done loading')
      );
    }
  






    updateSubjectInvoice(invoice_model){
      this._demoService.updateSubjectInvoice(invoice_model).subscribe(
        data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
    
    // // need to update the invoice items as well. or do we update them as we make changes to the invoice itself??? Start Here and work out.
    // // now inset the items
    // let  count_of_items = Object.keys(this.invoiceItemsList).length;
    //   // need to do a loop of subject_billing items (.length)
    //   for(let i=0; i < count_of_items; i++) {
    //    let invoiceData = this.invoiceItemsList[i];
    //    // :: add the items
    //    this.updateSubjectInvoiceItem(invoiceData, this.invoice_id);
    // // :: TODO need to update subjectBillingItem, as status invoiced.
    // let invoice_status = "INVOICED";
    // this.updateSubjectBillingItemInvoiceStatus(invoice_status, invoiceData.subject_billing_item_id, this.invoice_id, this.invoice_number);
    //   } // end for
    
    
      this.toastr.success('Invoice Updated');
      // this.closeParentModel.emit();
      // this.refreshSujectInvoicePage(this.subject_id);
    
    
         return true;
        },
        error => {
          console.error(error);
       //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
    )
     }









    refreshGrid(){ // refresh the databutton
      // this.loadList(this.doc_id);
      this.getMyobPurchases();
      this.grid.refresh();
    };

// need to change this below
editBrand(model){
  // model.job_id = this.job_id;
   this._demoService.updateBrand(model).subscribe(
     data => {  // this.trace_candidate_update = data;
       // refresh the list
      // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
     this.toastr.success('Company Updated');
     this.gfunc.insertLog_UpdateCompany(model); // hadled in the global functions file.
    // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
    // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
     },
     error => {
      // console.error('Error saving Event!');
       this.toastr.error('Error Updating Brand');
      return console.log(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
 );}




// New way of rendering table data
mapJobTableLiveClients() {

  this.getBrandBrandTypes();
  this.getUsers();
  

  this.http.get<any>(this.gfunc.apiURL + 'api/brands/clients')
 .pipe(map(data => {
  // do your transformations
  this.job_table_clients = data;

  this.job_table_clients.forEach(element => {
    element.primary_contact = ''; // removed undefined from table

/*
// local Client Name
this.clientLocalRecord = this.clients.filter(c => c.client_id === element.client_id);
let rs = this.clientLocalRecord;
this.changeObject = Object.assign(this.clientLocalRecord);
element.client_id  = this.changeObject[0].name;
*/

// commented out so that brand_type_id do not change to a word.
// this.btLocalRecord = this.brand_types.filter(c => c.brand_type_id === element.brand_type_id);
// this.changeObject = Object.assign(this.btLocalRecord);
//   element.brand_type_id  = this.changeObject[0].brand_type_name;

// get user counts per brand - Changes the actual Brand Type ID>...
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount = this.changeObject.length;
element.contacts  = this.changeObject.length;



// get user counts per brand
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id && c.is_primary_contact == 1);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount2 = this.changeObject.length;
// element.contacts  = this.changeObject.length;
// need to filter this element objects of users to get the primary contact.
if (recordCount2 < 1){
  element.primary_contact = '-';
}else{
  for (let i = 0; i < recordCount2; i++) {
    element.primary_contact  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
} // end loop
}// end if


}); // end for each of all


return this.job_table_clients3;
})
 )
  .subscribe(results => this.job_table_clients3 = results
  );

}





getBrandBrandTypes(){
  this._demoService.getBrandBrandTypes().subscribe(
    data => { this.brand_types = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

getUsers() {
  this._demoService.getUsers().subscribe(
    data => { this.users = data;
      this.usersPrimary = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


brandView(brand_id) {
  this.router.navigate(['/admin/brands/company/view/' + brand_id + '']);
}

brandEdit(brand_id) {
  this.router.navigate(['/admin/brands/company/edit/' + brand_id + '']);
}



public getMyobCustomer(UID){
    this._demoService.getMyobCustomer(UID).subscribe(
      data => { this.myobCustomer = data;
        let res = data[0];
         this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
         // console.log(this.arrCase);
         this.customerItem = data['Item'] ;
        // console.log(this.customerItem);
        // this.Address = this.Items['Address'];
      },
      err => {
        // this.toastr.error('You need to login to MYOB again, Connection lost!');
        console.error(err);
      },
      // () => console.log('done loading')
    );
  }



  // the declared vars
  //  myobContactListMapped: MyobContact[];
  getMyobCustomerMapped(UID) {
   this._demoService.getMyobCustomerMapped(UID)
    .subscribe((data:any) => {
       console.log(data);
     // many
       // this.myobContactListMapped = data.data;
     //single
       this.myobContactListMapped = data.data;
    });
  }


  


}
